// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1d5VS","title":"Info_title__SSal-","links":"Info_links__2hM2q","link":"Info_link__1eJnT","logo":"Info_logo__1Nbcn"};